import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare, faBuilding, faXmark } from '@fortawesome/free-solid-svg-icons';
import { BASE_URL } from '../../utils/constants'
import Navigation from '../../Layouts/Navigation/Navigation'

function AdminTowers() {
  const [towers, setTowers] = useState([]);
  const [filteredTowers, setFilteredTowers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [open, setOpen] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [towerId, setTowerId] = useState('');
  const [nombre_torre, setNombreTorre] = useState('');
  const [cant_pisos, setCantPisos] = useState('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [openAlert, setOpenAlert] = useState(false);
  const [snackMessage, setSnackMessage] = useState('');
  const [snackStatus, setSnackStatus] = useState('');

  const [selectedTower, setSelectedTower] = useState(null);

  const handleClickOpen = () => {
    setOpen(true);
  }

  const handleClose = () => {
    setOpen(false);
  }

  const handleEdit = (id_torre) => {
    setTowerId(id_torre);
    setOpenEdit(true);
  }

  const handleCloseAlert = () => {
    setOpenAlert(false);
  }

  const handleCloseSnack = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenAlert(false);
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  }

  const handleClickSnack = () => {
    setOpenAlert(true);
  }

  useEffect(() => {
    getTowers();
  }, []);

  const getTowers = () => {
    axios.get(`${BASE_URL}/towers`)
      .then((response) => {
        setTowers(response.data);
        setFilteredTowers(response.data);
      })
      .catch((error) => console.error('Error fetching towers:', error));
  }

  const handleAddSubmit = (event) => {
    event.preventDefault();

    const towerData = {
      nombre: nombre_torre,
      cant_pisos: cant_pisos
    }

    console.log(towerData);

    axios.post(`${BASE_URL}/addTower`, towerData)
      .then((response) => {
        if (response.status === 200) {
          setSnackStatus('success');
          setSnackMessage('Torre agregada con éxito!');
          getTowers();
        } else if (response.status === 500) {
          setSnackStatus('error');
          setSnackMessage('Error al agregar la torre.');
        }
        handleClickSnack();
      }
    ).catch((error) => {
      console.error('Error adding tower:', error);
      setSnackStatus('error');
      setSnackMessage('Error al agregar la torre.');
      handleClickSnack();
    });
  }

  const handleEditTower = (tower) => {
    setSelectedTower(tower);
    setOpenEdit(true);
  }

  const handleEditSubmit = (event) => {
    event.preventDefault();

    const towerData = {
      nombre: selectedTower.nombre,
      cant_pisos: selectedTower.cant_pisos
    }

    axios.put(`${BASE_URL}/updateTower/${selectedTower.id_torre}`, {
      ...towerData,
      id_torre: selectedTower.id_torre
    })
      .then((response) => {
        if (response.status === 200) {
          setSnackStatus('success');
          setSnackMessage('Torre actualizada con éxito!');
          getTowers();
          setOpenEdit(false);
        } else if (response.status === 500) {
          setSnackStatus('error');
          setSnackMessage('Error al actualizar la torre.');
        }
        handleClickSnack();
      }
    ).catch((error) => {
      console.error('Error updating tower:', error);
      setSnackStatus('error');
      setSnackMessage('Error al actualizar la torre.');
      handleClickSnack();
    });
  }

  const handleSearch = (event) => {
    const value = event.target.value.toLowerCase();
    setSearchTerm(value);
    const filtered = towers.filter((tower) =>
      tower.nombre.toLowerCase().includes(value) ||
      tower.cant_pisos.toString().includes(value)
    );
    setFilteredTowers(filtered);
    setPage(0);
  };
    
    
  return (
    <>
      <Navigation/>
      <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 p-4 sm:p-6 lg:p-8">
        <div className="max-w-7xl mx-auto">
          {/* Snackbar Alert */}
          {openAlert && (
            <div className={`fixed top-4 right-4 z-[9999] p-4 rounded-lg shadow-lg ${
              snackStatus === 'success' ? 'bg-green-500' : 'bg-red-500'
            } text-white animate-fade-in-down`}>
              <div className="flex items-center gap-2">
                <span>{snackMessage}</span>
                <button onClick={handleCloseAlert} className="ml-2">
                  <FontAwesomeIcon icon={faXmark} className="h-5 w-5" />
                </button>
              </div>
            </div>
          )}

          {/* Header */}
          <div className="mb-8">
            <div className="flex items-center justify-center gap-3 mb-6">
              <FontAwesomeIcon icon={faBuilding} className="h-10 w-10 text-primary-600" />
              <h1 className="text-4xl font-bold text-gray-800">Administrar Torres</h1>
            </div>
            
            {/* Search and Add Button */}
            <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center justify-between mb-6">
              <div className="flex-1 w-full sm:max-w-md">
                <input
                  type="text"
                  placeholder="Buscar por nombre o cantidad de pisos..."
                  value={searchTerm}
                  onChange={handleSearch}
                  className="input-field w-full"
                />
              </div>
              <button
                onClick={handleClickOpen}
                className="btn-primary flex items-center gap-2 whitespace-nowrap"
              >
                <FontAwesomeIcon icon={faBuilding} className="h-5 w-5" />
                Agregar Torre
              </button>
            </div>
          </div>

          {/* Modal para agregar torre */}
          {open && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
              <div className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
                <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 rounded-t-2xl">
                  <h2 className="text-2xl font-bold text-gray-800">Agregar Torre</h2>
                  <p className="text-gray-600 mt-1">Ingrese la información de la nueva torre</p>
                </div>
                <form onSubmit={handleAddSubmit}>
                  <div className="p-6 space-y-4">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          Nombre de la Torre
                        </label>
                        <input
                          type="text"
                          className="input-field"
                          value={nombre_torre}
                          onChange={(e) => setNombreTorre(e.target.value)}
                          required
                          autoFocus
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          Cantidad de Pisos
                        </label>
                        <input
                          type="number"
                          className="input-field"
                          value={cant_pisos}
                          onChange={(e) => setCantPisos(e.target.value)}
                          required
                          min="1"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="sticky bottom-0 bg-gray-50 px-6 py-4 rounded-b-2xl flex justify-end gap-3 border-t border-gray-200">
                    <button
                      type="button"
                      onClick={handleClose}
                      className="px-6 py-2.5 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition-colors font-medium"
                    >
                      Cancelar
                    </button>
                    <button
                      type="submit"
                      className="btn-primary"
                    >
                      Agregar Torre
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}

          {/* Modal para editar torre */}
          {openEdit && selectedTower && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
              <div className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
                <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 rounded-t-2xl">
                  <h2 className="text-2xl font-bold text-gray-800">Editar Torre</h2>
                  <p className="text-gray-600 mt-1">Modifique la información de la torre</p>
                </div>
                <form onSubmit={handleEditSubmit}>
                  <div className="p-6 space-y-4">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          Nombre de la Torre
                        </label>
                        <input
                          type="text"
                          className="input-field"
                          value={selectedTower.nombre}
                          onChange={(event) => setSelectedTower({...selectedTower, nombre: event.target.value})}
                          required
                          autoFocus
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          Cantidad de Pisos
                        </label>
                        <input
                          type="number"
                          className="input-field"
                          value={selectedTower.cant_pisos}
                          onChange={(event) => setSelectedTower({...selectedTower, cant_pisos: event.target.value})}
                          required
                          min="1"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="sticky bottom-0 bg-gray-50 px-6 py-4 rounded-b-2xl flex justify-end gap-3 border-t border-gray-200">
                    <button
                      type="button"
                      onClick={() => setOpenEdit(false)}
                      className="px-6 py-2.5 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition-colors font-medium"
                    >
                      Cancelar
                    </button>
                    <button
                      type="submit"
                      className="btn-primary"
                    >
                      Guardar Cambios
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}

          {/* Table */}
          <div className="bg-white rounded-2xl shadow-md overflow-hidden">
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gradient-to-r from-primary-500 to-primary-700">
                  <tr>
                    <th className="px-6 py-4 text-center text-sm font-bold text-white uppercase tracking-wider">
                      Nombre
                    </th>
                    <th className="px-6 py-4 text-center text-sm font-bold text-white uppercase tracking-wider">
                      Cantidad de Pisos
                    </th>
                    <th className="px-6 py-4 text-center text-sm font-bold text-white uppercase tracking-wider">
                      Acciones
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {filteredTowers
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((tower) => (
                      <tr key={tower.id_torre} className="hover:bg-gray-50 transition-colors">
                        <td className="px-6 py-4 text-center text-sm font-medium text-gray-900">
                          {tower.nombre}
                        </td>
                        <td className="px-6 py-4 text-center text-sm text-gray-700">
                          {tower.cant_pisos}
                        </td>
                        <td className="px-6 py-4 text-center">
                          <button
                            onClick={() => handleEditTower(tower)}
                            className="inline-flex items-center gap-2 px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors shadow-sm hover:shadow-md"
                            title="Editar torre"
                          >
                            <FontAwesomeIcon icon={faPenToSquare} className="h-5 w-5" />
                            Editar
                          </button>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
            
            {/* Pagination */}
            <div className="bg-gray-50 px-6 py-4 flex items-center justify-between border-t border-gray-200">
              <div className="flex items-center gap-2">
                <span className="text-sm text-gray-700">Filas por página:</span>
                <select
                  value={rowsPerPage}
                  onChange={handleChangeRowsPerPage}
                  className="input-field py-1 px-2 text-sm"
                >
                  <option value={5}>5</option>
                  <option value={10}>10</option>
                  <option value={25}>25</option>
                </select>
              </div>
              <div className="flex items-center gap-4">
                <span className="text-sm text-gray-700">
                  {page * rowsPerPage + 1}-{Math.min((page + 1) * rowsPerPage, filteredTowers.length)} de {filteredTowers.length}
                </span>
                <div className="flex gap-2">
                  <button
                    onClick={(e) => handleChangePage(e, page - 1)}
                    disabled={page === 0}
                    className="px-3 py-1 bg-white border border-gray-300 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50 transition-colors"
                  >
                    Anterior
                  </button>
                  <button
                    onClick={(e) => handleChangePage(e, page + 1)}
                    disabled={page >= Math.ceil(filteredTowers.length / rowsPerPage) - 1}
                    className="px-3 py-1 bg-white border border-gray-300 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50 transition-colors"
                  >
                    Siguiente
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default AdminTowers
